import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgAuthModule } from '@principle-theorem/ng-auth';
import { NgEditorModule } from '@principle-theorem/ng-editor';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import {
  ComponentsModule,
  NgPrincipleModule,
} from '@principle-theorem/ng-principle';
import {
  NgPrincipleSharedModule,
  OrganisationSelectorComponent,
  OrganisationStatusComponent,
} from '@principle-theorem/ng-principle-shared';
import { NgSharedModule } from '@principle-theorem/ng-shared';
import { ManageSmsIntegrationComponent } from '../settings/integrations/manage-sms-integration/manage-sms-integration.component';
import { BigQueryUploadsComponent } from './big-query-uploads/big-query-uploads.component';
import { MigrationRunnerComponent } from './migration-runner/migration-runner.component';
import { OrgUserEditComponent } from './org-user-edit/org-user-edit.component';
import { OrganisationAddDialogComponent } from './organisation-add-dialog/organisation-add-dialog.component';
import { OrganisationEditComponent } from './organisation-edit/organisation-edit.component';
import { OrganisationSubscriptionDialogComponent } from './organisation-edit/organisation-subscription-dialog/organisation-subscription-dialog.component';
import { OrganisationsComponent } from './organisations/organisations.component';
import { RoleEditComponent } from './role-edit/role-edit.component';
import { RoleListComponent } from './role-list/role-list.component';
import { SeedDemoSpaceComponent } from './seed-demo-space/seed-demo-space.component';
import { ToolCardComponent } from './tools/tool-card/tool-card.component';
import { ToolsComponent } from './tools/tools.component';
import { UserListComponent } from './user-list/user-list.component';

@NgModule({
  declarations: [
    OrganisationsComponent,
    OrganisationAddDialogComponent,
    OrganisationEditComponent,
    OrgUserEditComponent,
    ToolsComponent,
    MigrationRunnerComponent,
    RoleEditComponent,
    RoleListComponent,
    UserListComponent,
  ],
  imports: [
    NgSharedModule,
    ComponentsModule,
    NgMaterialModule,
    NgPrincipleModule,
    ReactiveFormsModule,
    NgAuthModule,
    NgMaterialModule,
    NgEditorModule,
    NgPrincipleSharedModule,
    RouterModule,
    SeedDemoSpaceComponent,
    OrganisationSubscriptionDialogComponent,
    BigQueryUploadsComponent,
    OrganisationSelectorComponent,
    OrganisationStatusComponent,
    ManageSmsIntegrationComponent,
    ToolCardComponent,
  ],
  exports: [ToolCardComponent, MigrationRunnerComponent],
})
export class ManagementPagesModule {}
